import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, Input, Badge, Tooltip, Space, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faMagnifyingGlass,
  faMessage,
  faRightFromBracket,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setPopup } from "../../Redux/PopupSlice";
import "./Header.css";
import CreateAccModal from "./CreateAccModal/CreateAccModal";
import UserService from "../../Services/user.service";
import { setSearchValue } from "../../Redux/SearchSlice";

function Header() {
  const dispatch = useDispatch();
  const popupSelector = useSelector((state) => state.popup);
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  const [createAccModal, setCreateAccModal] = useState(null);
  const [searchResult, setSearchResult] = useState(null);
  const searchValueSelector = useSelector((state) => state.search.value);

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const accountSettingTooltipRef = useRef(null);

  useEffect(() => {
    setSearchResult(searchValueSelector);
  }, [searchValueSelector]);

  useEffect(() => {
    const handleBlurShowmore = (event) => {
      if (
        accountSettingTooltipRef.current &&
        !accountSettingTooltipRef.current.contains(event.target)
      ) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleBlurShowmore);
    return () => {
      document.removeEventListener("mousedown", handleBlurShowmore);
    };
  }, []);

  const handleSearchNavigate = () => {
    if (searchResult === null || searchResult === "") return;
    dispatch(setSearchValue({ value: searchResult }));
    setTimeout(() => {
      navigate("/search");
    }, 0);
  };

  const handleLogout = async () => {
    // await UserService.logOut();
    // toast.success("Đăng xuất thành công!");
    // navigate("/");

    UserService.logOut().then((res) => {
      localStorage.removeItem("userInfo");
      toast.success(res?.message);
      setTimeout(() => {
        navigate("/");
      }, 0);
    });
  };

  const handleShowProfile = async () => {
    setShowProfile(false);
    setTimeout(() => {
      navigate(`/profile/${userInfo?.id}`);
    }, 0);
  };

  return (
    <>
      <Row className="header">
        <Col span={6} offset={3} className="headerLeftWrapper">
          <div className="headerLogoWrapper">
            <img
              className="headerLogo"
              src="/logoVer2.png"
              onClick={() => navigate("/home")}
            />
          </div>
          <Button className="headerLeftBtn" onClick={() => navigate("/home")}>
            Trang chủ
          </Button>
          <Button className="headerLeftBtn">Feed</Button>
        </Col>
        <Col span={6} className="appHeaderSearch">
          <Space.Compact block>
            <Input
              placeholder="Search"
              className="chatMenuInput"
              value={searchResult}
              onPressEnter={handleSearchNavigate}
              onChange={(e) => setSearchResult(e.target.value)}
              suffix={
                <FontAwesomeIcon
                  onClick={handleSearchNavigate}
                  icon={faMagnifyingGlass}
                  style={{ cursor: "pointer" }}
                />
              }
            />
          </Space.Compact>
        </Col>
        <Col span={6} className="appHeaderFtn">
          {userInfo ? (
            <>
              <Badge
                count={0}
                size="small"
                style={{ top: "5px", right: "3px", borderColor: "#FF4D4F" }}
              >
                <Button
                  className="headerBtn"
                  onClick={() =>
                    dispatch(
                      setPopup(popupSelector === "message" ? null : "message")
                    )
                  }
                  onMouseDown={(e) => e.stopPropagation()}
                  shape="circle"
                  color="default"
                  variant="filled"
                >
                  <FontAwesomeIcon icon={faMessage} />
                </Button>
              </Badge>
              <Badge
                count={0}
                size="small"
                style={{ top: "5px", right: "3px", borderColor: "#FF4D4F" }}
              >
                <Button
                  disabled
                  className="headerBtn"
                  onClick={() =>
                    dispatch(
                      setPopup(
                        popupSelector === "notification" ? null : "notification"
                      )
                    )
                  }
                  onMouseDown={(e) => e.stopPropagation()}
                  shape="circle"
                  color="default"
                  variant="filled"
                >
                  <FontAwesomeIcon icon={faBell} />
                </Button>
              </Badge>

              <div ref={accountSettingTooltipRef}>
                <Tooltip
                  placement="bottom"
                  open={showProfile}
                  overlayStyle={{ width: "150px" }}
                  color="whiteSmoke"
                  title={
                    <div
                      className="profileTooltip"
                      onMouseDown={(e) => e.stopPropagation()}
                    >
                      <Row className="profileTooltipRow">
                        <Col span={4} className="profileTooltipIcon">
                          <FontAwesomeIcon icon={faUser} />
                        </Col>
                        <Col span={20} onClick={handleShowProfile}>
                          <p>Trang cá nhân</p>
                        </Col>
                      </Row>
                      <Row className="profileTooltipRow">
                        <Col span={4} className="profileTooltipIcon">
                          <FontAwesomeIcon icon={faRightFromBracket} />
                        </Col>
                        <Col span={20}>
                          <p onClick={handleLogout}>Đăng xuất</p>
                        </Col>
                      </Row>
                    </div>
                  }
                >
                  <Button
                    className="headerBtn"
                    shape="circle"
                    color="default"
                    variant="filled"
                    onClick={() => setShowProfile((prev) => !prev)}
                  >
                    <img
                      style={{
                        borderRadius: "50%",
                        width: "32px",
                        height: "32px",
                        objectFit: "cover",
                      }}
                      src={userInfo?.avatar || "/blankAvatarImg.jpg"}
                      alt="avatar"
                    />
                  </Button>
                </Tooltip>
              </div>
            </>
          ) : (
            <>
              <Button
                onClick={() => setCreateAccModal("signIn")}
                className="headerBtn createAcc"
              >
                Đăng nhập
              </Button>
              <Button
                onClick={() => setCreateAccModal("createAcc")}
                className="headerBtn createAcc"
              >
                Tạo tài khoản
              </Button>
              <CreateAccModal
                openModal={createAccModal}
                setCreateAccModal={setCreateAccModal}
              />
            </>
          )}
        </Col>
      </Row>
      <Row className="headerSpace" />
    </>
  );
}

export default Header;
